const underworld = require('sci/std/underworld')
const gql = require('graphql-tag')

module.exports = underworld.registerEventType(
    'notification',
    gql`
            fragment NotificationEvent on NotificationEvent {
                notification {
                    id
                    type
                    subject
                    plainSubject
                    content
                    plainContent
                    meta
                    createdAt
                    deletedAt
                    viewedAt
                    resources {
                        id
                        type
                        urn
                        path
                        isValid
                    }
                    sources {
                        id
                        type
                        isValid
                        sourceId
                    }
                }
            }
        `
);


// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/subscriptions/notifications.js